import axios from "axios";

const urlApi = `${process.env.REACT_APP_MICRO_GLOBAL_ENTITY}qualify_property_for_habi`;
const apiKey = process.env.REACT_APP_MICRO_GLOBAL_ENTITY_XAPIKEY;

export const getHistory = async ({ token }) => {
    const url = `${urlApi}/get_history?country=MX`;
    const headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'x-api-key': apiKey
    }
    const res = await axios.get(url, { headers: headers });
    return res?.data || [];
};

export const getExportHistory = async ({ token, id }) => {
    const url = `${urlApi}/export_history?country=MX&export_id=${id}`;
    const headers = {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'x-api-key': apiKey
    }
    const res = await axios.get(url, { headers: headers });
    return res?.data || [];
};
